import { createFileRoute } from "@tanstack/react-router";
import { AccountPage } from "../../features/account";

const VALID_TABS = ["overview", "bookings", "saved", "reviews", "profile"] as const;
type AccountTab = (typeof VALID_TABS)[number];

export const Route = createFileRoute("/_authed/account")({
  component: AccountPage,
  validateSearch: (search: Record<string, unknown>): { tab?: AccountTab } => {
    const raw = typeof search.tab === "string" ? search.tab : undefined;
    return raw && (VALID_TABS as readonly string[]).includes(raw)
      ? { tab: raw as AccountTab }
      : {};
  },
});
